import React from "react";
import { Layout } from "antd";
import MiCompAPI from "../../util/api";

const { Content } = Layout;

class PendingComplianceReport extends React.Component {
  constructor(props) {
    super(props);

    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  render() {
    const { decodedToken } = this.props.userPermandMasters;

    var role = decodedToken.UserRoleName;
    var userdId = decodedToken.UserId;

    return (
      <Content>
        <div className="mi_main_div" style={{ paddingTop: "1px" }}>
          <div
            style={{
              textAlign: "center",
              alignContent: "center",
              marginTop: "3%",
            }}
          >
            {userdId === "10302" && (
              <iframe
                title="Carrier_V1(New)_ComplianceReport"
                width="1024"
                height="612"
                src="https://app.powerbi.com/view?r=eyJrIjoiN2IwZjhhMDctNDQxMC00YTYwLTllODItNzliZjMzYTI4YWI5IiwidCI6ImZjOGM4MTM5LTk1YTktNDRiNC1hMzg0LWQ1YzBhOGExYmQxMCIsImMiOjN9"
                frameborder="0"
                allowFullScreen="true"
              ></iframe>
            )}
          </div>
        </div>
      </Content>
    );
  }
}
export default PendingComplianceReport;
